export default "__VITE_ASSET__CpEWnHzN__"